/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Why_GoalInputs */

const en_us2_profile_why_goal = /** @type {(inputs: Profile_Why_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets the sets, reps and rest of your protocol.`)
};

const pt_br2_profile_why_goal = /** @type {(inputs: Profile_Why_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Define séries, repetições e descanso do seu protocolo.`)
};

const es_419_profile_why_goal = /** @type {(inputs: Profile_Why_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Define las series, repeticiones y descanso de tu protocolo.`)
};

const pt_pt2_profile_why_goal = /** @type {(inputs: Profile_Why_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Define as séries, repetições e descanso do teu protocolo.`)
};

const fr_fr2_profile_why_goal = /** @type {(inputs: Profile_Why_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fixe les séries, répétitions et repos de ton protocole.`)
};

const de_de2_profile_why_goal = /** @type {(inputs: Profile_Why_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legt Sätze, Wiederholungen und Pausen deines Protokolls fest.`)
};

const it_it2_profile_why_goal = /** @type {(inputs: Profile_Why_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stabilisce serie, ripetizioni e recupero del tuo protocollo.`)
};

/**
* | output |
* | --- |
* | "Sets the sets, reps and rest of your protocol." |
*
* @param {Profile_Why_GoalInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_why_goal = /** @type {((inputs?: Profile_Why_GoalInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Why_GoalInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_why_goal(inputs)
	if (locale === "es-419") return es_419_profile_why_goal(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_why_goal(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_why_goal(inputs)
	if (locale === "de-DE") return de_de2_profile_why_goal(inputs)
	if (locale === "it-IT") return it_it2_profile_why_goal(inputs)
	return en_us2_profile_why_goal(inputs)
});
export { profile_why_goal as "profile.why_goal" }